import React from "react";
import PropTypes from "prop-types";

import Modal from "../Modals/Modal";

const SportsBetSuccessModal = ({ show, onClose }) => (
  <Modal
    isOpen={Boolean(show)}
    onClose={onClose}
    maxWidth={380}
    zIndex={9200}
    dialogLabel="베팅이 완료되었습니다"
    panelClassName="member-notice-dialog-panel sports-bet-success-dialog-panel"
  >
    <div className="member-notice-content sports-bet-success-content">
      <span className="sports-bet-success-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="m5 12.5 4.1 4.1L19 7" />
        </svg>
      </span>
      <span className="member-notice-label">SPORTS BET</span>
      <strong>베팅이 완료되었습니다</strong>
      <p>접수된 베팅은 베팅내역에서 선택지와 진행 상태를 확인할 수 있습니다.</p>
      <div className="member-notice-actions sports-bet-success-actions">
        <button type="button" className="notice-primary" onClick={onClose}>
          확인
        </button>
      </div>
    </div>
  </Modal>
);

SportsBetSuccessModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

SportsBetSuccessModal.defaultProps = {
  show: false,
};

export default SportsBetSuccessModal;
